export const APP_ICON_CHOICES = [
  { symbol: "table", label: "Ledger" },
  { symbol: "checklist", label: "Tasks" },
  { symbol: "calendar", label: "Calendar" },
  { symbol: "chart", label: "Analytics" },
  { symbol: "wallet", label: "Finance" },
  { symbol: "people", label: "Contacts" },
  { symbol: "mail", label: "Inbox" },
  { symbol: "shopping", label: "Shopping" },
  { symbol: "briefcase", label: "Projects" },
  { symbol: "globe", label: "Website" },
  { symbol: "file", label: "Documents" },
  { symbol: "search", label: "Research" },
  { symbol: "palette", label: "Design" },
  { symbol: "code", label: "Development" },
  { symbol: "workflow", label: "Workflow" },
  { symbol: "shield", label: "Security" },
  { symbol: "bug", label: "Issue tracker" },
  { symbol: "heart", label: "Health" },
  { symbol: "layers", label: "Collection" },
  { symbol: "database", label: "Database" },
] as const;
export const APP_ICON_COLORS = ["blue", "purple", "amber", "teal", "orange", "pink"] as const;
export type AppIcon = {
  symbol: (typeof APP_ICON_CHOICES)[number]["symbol"];
  color: (typeof APP_ICON_COLORS)[number];
};
export type AppIconPreference = { value: AppIcon; source: "app" | "user" };
export const appIconColors: Record<AppIcon["color"], string> = {
  blue: "text-library-site",
  purple: "text-library-app",
  amber: "text-library-code",
  teal: "text-library-page",
  orange: "text-library-slides",
  pink: "text-library-image",
};
export function isAppIcon(value: unknown): value is AppIcon {
  if (!value || typeof value !== "object") return false;
  const icon = value as AppIcon;
  return (
    APP_ICON_CHOICES.some((choice) => choice.symbol === icon.symbol) &&
    APP_ICON_COLORS.some((color) => color === icon.color)
  );
}

/** Exact, bounded metadata only. No app code, HTML mounting, remote images or title guessing. */
export function declaredAppIcon(html: string): AppIcon | null {
  const head = html.slice(0, 65536).split(/<\/head\s*>/i)[0] ?? "";
  const values = new Map<string, string>();
  const markup = head.replace(/<!--[\s\S]*?-->|<script\b[^>]*>[\s\S]*?<\/script\s*>/gi, "");
  for (const tag of markup.matchAll(/<meta\b[^>]{0,2048}>/gi)) {
    const attrs = new Map<string, string>();
    for (const match of tag[0].matchAll(/([a-zA-Z-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/g))
      attrs.set(match[1]!.toLowerCase(), match[2] ?? match[3] ?? match[4] ?? "");
    const name = attrs.get("name")?.toLowerCase();
    if (name === "wurkees:app-icon" || name === "wurkees:app-color")
      values.set(name, attrs.get("content") ?? "");
  }
  const icon = {
    symbol: values.get("wurkees:app-icon"),
    color: values.get("wurkees:app-color") ?? "purple",
  };
  return isAppIcon(icon) ? icon : null;
}
